/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const ptBRRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Solicitação para adicionar Escola',
    description: 'Preencha o formulário abaixo. Não garantimos que as escolas enviadas serão adicionadas, mas todas as solicitações são pesquisadas e consideradas pelo SheerID. ',
    noCountry: 'Não encontrou o país da sua escola? Esta oferta não é válida para você',
    searchByOrgName: 'Não encontrou sua escola? Procurar por nome',
    completeRequest: 'Não encontrou sua escola na lista de escolas elegíveis ou inelegíveis? Termine sua solicitação',
    submit: 'Enviar',
    eligibleOrgs: 'Escolas elegíveis Clique no ícone para copiar o nome e volte para o formulário de verificação',
    ineligibleOrgs: 'Escolar inelegíveis. Desculpe, esta oferta não é válida para alunos dessa escola',
    none: 'Nenhum',
    country: 'Qual escola você frequenta?',
    changeLanguage: 'Mudar idioma',
    copied: 'Copiado',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    emailAddress: 'E-mail',
    poweredBy: 'Serviços de verificação fornecidos pelo SheerID',
    fields: {
        countryPlaceholder: 'Selecionar País',
        domainLabel: 'Selecionar site',
        domainPlaceholder: 'www.minhauniversidade.br',
        orgNameLabel: 'Nome da Escola',
        orgNamePlaceholder: 'Minha escola',
    },
    step: {
        success: {
            title: 'Obrigado!',
            description: 'Recebemos seu pedido de adição de uma instituição educacional. Tenha em mente que o prazo de pesquisa da sua solicitação pode ser de até sete dias e que não há garantias de que sua instituição será adicionada à lista de instituições educacionais qualificadas, elegíveis ao acesso educacional a produtos Autodesk.<br><br>Enquanto isso, você pode pesquisar opções alternativas de assinatura.',
        },
        error: {
            title: 'Ocorreu um erro inesperado',
            description: 'Não conseguimos processar sua solicitação. Tente novamente mais tarde',
            seeingProblem: 'Se você continuar encontrando esse problema',
            contactUs: 'entre em contato',
        },
    },
    errorId: {
        invalidCountry: 'Esse campo é obrigatório',
        invalidEmail: 'E-mail inválido',
        invalidFirstName: 'Nome inválido',
        invalidLastName: 'Sobrenome inválido',
        requiredField: 'Esse campo é obrigatório',
        invalidField: 'Campo inválido',
        invalidUrl: 'URL inválido',
        tooManyResults: 'Encontramos muitos resultados para sua pesquisa, refine a pesquisa e tente novamente',
    },
    faq: 'SheerID Adicionar solicitação de escola FAQ',
    countries: {
        AD: 'Andorra',
        AE: 'Emirados Árabes Unidos',
        AF: 'Afeganistão',
        AG: 'Antígua e Barbuda',
        AI: 'Anguilla',
        AL: 'Albânia',
        AM: 'Armênia',
        AN: 'Antilhas Holandesas',
        AO: 'Angola',
        AR: 'Argentina',
        AS: 'Samoa Americana',
        AT: 'Áustria',
        AU: 'Austrália',
        AW: 'Aruba',
        AZ: 'Azerbaijão',
        BA: 'Bósnia e Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Bélgica',
        BF: 'Burkina Faso',
        BG: 'Bulgária',
        BH: 'Bahrein',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermudas',
        BN: 'Brunei Darussalam',
        BO: 'Bolívia',
        BR: 'Brasil',
        BS: 'Bahamas',
        BT: 'Butão',
        BV: 'Ilha Bovet',
        BW: 'Botsuana',
        BY: 'Bielorrússia',
        BZ: 'Belize',
        CA: 'Canadá',
        CD: 'República Democrática do Congo',
        CF: 'República Centro-Africana',
        CG: 'Congo',
        CH: 'Suíça',
        CI: 'Costa do Marfim',
        CK: 'Ilhas Cook',
        CL: 'Chile',
        CM: 'Camarões',
        CN: 'China',
        CO: 'Colômbia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cabo Verde',
        CY: 'Chipre',
        CZ: 'República Tcheca',
        DE: 'Alemanha',
        DJ: 'Djibuti',
        DK: 'Dinamarca',
        DM: 'Dominica',
        DO: 'República Dominicana',
        DZ: 'Argélia',
        EC: 'Equador',
        EE: 'Estônia',
        EG: 'Egito',
        EH: 'Saara Ocidental',
        ER: 'Eritreia',
        ES: 'Espanha',
        ET: 'Etiópia',
        FI: 'Finlândia',
        FJ: 'Fiji',
        FK: 'Ilhas Falklands',
        FM: 'Micronésia',
        FO: 'Ilhas Faroe',
        FR: 'França',
        GA: 'Gabão',
        GB: 'Reino Unido',
        GD: 'Granada',
        GE: 'Geórgia',
        GF: 'Guiana Francesa',
        GH: 'Gana',
        GI: 'Gibraltar',
        GL: 'Groenlândia',
        GM: 'Gâmbia',
        GN: 'Guiné',
        GP: 'Guadalupe (francesa)',
        GQ: 'Guiné Equatorial',
        GR: 'Grécia',
        GS: 'Ilhas Geórgia do Sul e Sandwich do Sul',
        GT: 'Guatemala',
        GU: 'Guam (EUA)',
        GW: 'Guiné-Bissau',
        GY: 'Guiana',
        HK: 'Hong Kong',
        HM: 'Ilhas Heard e McDonald',
        HN: 'Honduras',
        HR: 'Croácia',
        HT: 'Haiti',
        HU: 'Hungria',
        ID: 'Indonésia',
        IE: 'Irlanda',
        IL: 'Israel',
        IN: 'Índia',
        IO: 'Território Britânico do Oceano Índico',
        IQ: 'Iraque',
        IR: 'Irã',
        IS: 'Islândia',
        IT: 'Itália',
        JM: 'Jamaica',
        JO: 'Jordânia',
        JP: 'Japão',
        KE: 'Quênia',
        KG: 'Quirguistão',
        KH: 'Camboja',
        KI: 'Kiribati',
        KM: 'Comores',
        KN: 'São Cristóvão e Nevis Anguilla',
        KP: 'Coreia do Norte',
        KR: 'Coreia do Sul',
        KW: 'Kuwait',
        KY: 'Ilhas Cayman',
        KZ: 'Cazaquistão',
        LA: 'Laos',
        LB: 'Líbano',
        LC: 'Santa Lúcia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Libéria',
        LS: 'Lesoto',
        LT: 'Lituânia',
        LU: 'Luxemburgo',
        LV: 'Letônia',
        LY: 'Líbia',
        MA: 'Marrocos',
        MC: 'Mônaco',
        MD: 'Moldávia',
        ME: 'Montenegro',
        MG: 'Madagáscar',
        MH: 'Ilhas Marshall',
        MK: 'Macedônia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongólia',
        MO: 'Macau',
        MP: 'Ilhas Marianas do Norte',
        MQ: 'Martinica (francesa)',
        MR: 'Mauritânia',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Ilhas Maurício',
        MV: 'Maldivas',
        MW: 'Malauí',
        MX: 'México',
        MY: 'Malásia',
        MZ: 'Moçambique',
        NA: 'Namíbia',
        NC: 'Nova Caledônia (francês)',
        NE: 'Níger',
        NF: 'Ilha Norfolk',
        NG: 'Nigéria',
        NI: 'Nicarágua',
        NL: 'Países Baixos',
        NO: 'Noruega',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nova Zelândia',
        OM: 'Omã',
        PA: 'Panamá',
        PE: 'Peru',
        PF: 'Polinésia (francesa)',
        PG: 'Papua Nova Guiné',
        PH: 'Filipinas',
        PK: 'Paquistão',
        PL: 'Polônia',
        PM: 'São Pedro e Miquelon',
        PN: 'Ilha Pitcairn',
        PR: 'Porto Rico',
        PS: 'Palestina',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguai',
        QA: 'Catar',
        RE: 'Reunião (francesa)',
        RO: 'Romênia',
        RS: 'Sérvia',
        RU: 'Federação Russa',
        RW: 'Ruanda',
        SA: 'Arábia Saudita',
        SB: 'Ilhas Salomão',
        SC: 'Seychelles',
        SD: 'Sudão',
        SE: 'Suécia',
        SG: 'Cingapura',
        SH: 'Santa Helena',
        SI: 'Eslovênia',
        SK: 'República Eslovaca',
        SL: 'Serra Leoa',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somália',
        SR: 'Suriname',
        SS: 'Sudão do Sul',
        ST: 'São Tomé e Príncipe',
        SV: 'El Salvador',
        SY: 'Síria',
        SZ: 'Suazilândia',
        TC: 'Ilhas Turcas e Caicos',
        TD: 'Chade',
        TF: 'Territórios Franceses do Sul',
        TG: 'Togo',
        TH: 'Tailândia',
        TJ: 'Tajiquistão',
        TK: 'Tokelau',
        TL: 'Timor-Leste',
        TM: 'Turquemenistão',
        TN: 'Tunísia',
        TO: 'Tonga',
        TR: 'Turquia',
        TT: 'Trindade e Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tanzânia',
        UA: 'Ucrânia',
        UG: 'Uganda',
        UM: 'Ilhas Menores Distantes dos EUA',
        US: 'Estados Unidos',
        UY: 'Uruguai',
        UZ: 'Uzbequistão',
        VA: 'Cidade do Vaticano',
        VC: 'São Vicente e Granadinas',
        VE: 'Venezuela',
        VG: 'Ilhas Virgens Britânicas',
        VI: 'Ilhas Virgens (EUA)',
        VN: 'Vietnã',
        VU: 'Vanuatu',
        WF: 'Ilhas Wallis e Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Iêmen',
        YT: 'Mayotte',
        ZA: 'África do Sul',
        ZM: 'Zâmbia',
        ZW: 'Zimbábue',
    },
    locales: {
        ar: 'Árabe',
        bg: 'Búlgaro',
        cs: 'Tcheco',
        da: 'Dinamarquês',
        de: 'Alemão',
        el: 'Grego',
        'en-GB': 'Inglês (Reino Unido)',
        'en-US': 'Inglês',
        'es-ES': 'Espanhol (Espanha)',
        es: 'Espanhol',
        fi: 'Finlandês',
        'fr-CA': 'Francês (Canadá)',
        fr: 'Francês',
        hr: 'Croata',
        hu: 'Húngaro',
        id: 'Indonésio',
        is: 'Islandês',
        it: 'Italiano',
        iw: 'Hebraico',
        ja: 'Japonês',
        ko: 'Coreano',
        lt: 'Lituano',
        ms: 'Malaio',
        nl: 'Holandês',
        no: 'Norueguês',
        pl: 'Polonês',
        'pt-BR': 'Português (Brasil)',
        pt: 'Português',
        ro: 'Romeno',
        ru: 'Russo',
        sk: 'Eslovaco',
        sl: 'Esloveno',
        sr: 'Sérvio',
        sv: 'Sueco',
        tr: 'Turco',
        'zh-HK': 'Chinês (Hong Kong)',
        zh: 'Chinês (tradicional)',
    },
};
